module.exports = __webpack_public_path__ + "img/cszq_partners_9.594f0076.jpg";